<template>
  <div>
    <div class="vue-step-wrapper">
      <vue-step
        style-type="style2"
        active-color="#4ce595"
        :now-step="2"
        :step-list="[
          $t('newAction.stepsLabels.selectMetric'),
          $t('newAction.stepsLabels.stepOne'),
          $t('newAction.stepsLabels.stepTwo'),
          $t('newAction.stepsLabels.stepThree'),
        ]"
      ></vue-step>
    </div>

    <div v-if="loading" />
    <div v-else class="wrapper">
      <div class="row">
        <div class="col-6">
          <section :class="sectionPosition">
            <div class="row">
              <div class="col-5">
                <action-name />
              </div>
              <div class="col-4">
                <action-type />
              </div>
              <div class="col-3" style="padding-top: 35px;">
                <div class="custom-switch">
                  <input
                    type="checkbox"
                    class="custom-control-input"
                    id="switch-pause-action"
                    v-model="action.paused"
                  />
                  <label class="custom-control-label" for="switch-pause-action"
                    >Pausar ação</label
                  >
                </div>
              </div>
            </div>
            <div class="row mt-2">
              <div
                :class="`${
                  this.company.resurveyEnabled && action.channel !== 'widget'
                    ? 'col-5'
                    : 'col-12'
                }`"
              >
                <action-channel />
              </div>
              <div
                v-if="
                  this.company.resurveyEnabled && action.channel !== 'widget'
                "
                class="col-4 fields-area"
              >
                <b-form-group>
                  <label class="idx-bold">{{
                    $t('newAction.stepOne.labels.actionType')
                  }}</label>
                  <b-form-radio-group
                    id="acton-type-radio-group"
                    :value="action.surveyType"
                    v-model="action.surveyType"
                  >
                    <b-form-radio value="survey">{{
                      $t('newAction.stepOne.labels.surveyType')
                    }}</b-form-radio>
                    <b-form-radio
                      v-if="action.channel !== 'click-to-call'"
                      value="resurvey"
                      >{{
                        $t('newAction.stepOne.labels.resurveyType')
                      }}</b-form-radio
                    >
                  </b-form-radio-group>
                </b-form-group>
              </div>
              <div
                class="col-3 fields-area"
                v-if="
                  action.channel == 'email' ||
                  action.channel == 'emailsms' ||
                  action.channel == 'link' ||
                  action.channel == 'qrcode' ||
                  action.channel == 'whatsapp'
                "
              >
                <b-form-group>
                  <label class="idx-bold">Multi idioma</label>
                  <b-form-radio-group
                    id="acton-lang-radio-group"
                    :value="action.multiLanguage"
                    v-model="action.multiLanguage"
                  >
                    <b-form-radio :value="false">Não</b-form-radio>
                    <b-form-radio :value="true">Sim</b-form-radio>
                  </b-form-radio-group>
                </b-form-group>
              </div>
            </div>

            <div
              class="row mt-2"
              v-if="action.channel == 'sms' || action.channel == 'emailsms'"
            >
              <div class="col-12">
                <sms-config />
              </div>
            </div>
            <div class="row mt-2">
              <div class="col-12">
                <question />
              </div>
            </div>
            <div class="row mt-2">
              <div class="col-12">
                <replies />
              </div>
            </div>
            <div class="row mt-4">
              <div class="col-12" v-if="checkRadioOptions">
                <comment-area-position />
              </div>
            </div>
            <div class="row mt-4" v-if="action.channel === 'email'">
              <div class="col-12">
                <additional-question />
              </div>
            </div>
            <div class="row mt-4" v-else-if="action.sms.config === 'link'">
              <div class="col-12">
                <additional-question />
              </div>
            </div>

            <div class="custom-switch mb-3" v-if="action.channel == 'totem'">
              <input
                type="checkbox"
                class="custom-control-input"
                id="switch-q-paginate"
                v-model="action.questionStepByStep"
              />
              <label class="custom-control-label" for="switch-q-paginate"
                >Uma pergunta por vez</label
              >
            </div>

            <div v-if="action.channel !== 'widget'" class="switch-area">
              <label class="idx-bold mr-1">
                {{ $t('newAction.stepOne.allAnswersRequired') }}
              </label>
              <span id="popover-target-required-answre">
                <font-awesome-icon
                  :icon="['fas', 'info-circle']"
                  style="font-size: 15px; color: #c1c1c1;"
                />
              </span>

              <div class="custom-switch float-right">
                <input
                  type="checkbox"
                  class="custom-control-input"
                  id="switch-required-answers"
                  v-model="action.allAnswersRequired"
                  :disabled="action.customMandatoryQuestion"
                />
                <label
                  class="custom-control-label"
                  for="switch-required-answers"
                ></label>
              </div>
            </div>

            <div v-if="action.channel !== 'widget'" class="switch-area">
              <label class="idx-bold mr-1">
                {{ $t('newAction.stepOne.customMandatoryQuestions') }}
              </label>
              <span id="popover-custom-mandatory-answer">
                <font-awesome-icon
                  :icon="['fas', 'info-circle']"
                  style="font-size: 15px; color: #c1c1c1;"
                />
              </span>

              <div class="custom-switch float-right">
                <input
                  type="checkbox"
                  class="custom-control-input"
                  id="switch-required-question"
                  v-model="action.customMandatoryQuestion"
                  :disabled="action.allAnswersRequired"
                />
                <label
                  class="custom-control-label"
                  for="switch-required-question"
                ></label>
              </div>

              <b-popover
                target="popover-custom-mandatory-answer"
                triggers="hover"
                placement="top"
              >
                <template #title>Obrigatório por pergunta adicional</template>
                <p>
                  Ao habilitar esta opção, irá exibir nas configurações<button
                    class="btn-gray"
                  >
                    <font-awesome-icon :icon="['fas', 'ellipsis-h']" />
                  </button>
                  de cada pergunta a possibilidade de deixar aquela pergunta
                  adicional obrigatória.
                </p>
              </b-popover>
            </div>
          </section>
        </div>
        <div :class="editorPosition">
          <section class="content-template">
            <action-templates />
          </section>
        </div>
      </div>
      <div>
        <div class="save-change">
        <div class="col-12 mt-2 next-area">
          <div v-if="loadingSave">
            <b-spinner
              variant="primary"
              type="grow"
              class="align-middle"
            ></b-spinner>
          </div>
          <button v-else @click="saveAction" class="btn btn-info">
            {{ $t('newAction.stepOne.saveChanges') }}
          </button>

        </div>
      </div>
    </div>
  </div>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import { mapFields } from 'vuex-map-fields';
import swal from 'sweetalert';
import vueStep from 'vue-step';
import actionTemplates from '@/components/molecules/action-templates';
import actionName from '@/components/molecules/action-name';
import actionType from '@/components/molecules/action-type';
import actionChannel from '@/components/molecules/action-channel';
import question from '@/components/molecules/question';
import replies from '@/components/molecules/replies';
import additionalQuestion from '@/components/molecules/additional-question';
import smsConfig from '@/components/molecules/sms-config';
import commentAreaPosition from '@/components/molecules/comment-area-position';
import EventBus from '../../../../eventBus';
import api from '../../../../services/api';

export default {
  components: {
    actionName,
    actionType,
    actionChannel,
    question,
    replies,
    additionalQuestion,
    actionTemplates,
    smsConfig,
    commentAreaPosition,
    vueStep,
  },

  data: () => ({
    loading: false,
    userAuth: null,
    actionId: null,
    prevRoute: null,
    checkRadioOptions: true,
    editorPosition: 'col-6',
    sectionPosition: 'col-12',
    returnSection: null,
    loadingSave: false,
  }),

  computed: {
    ...mapFields('actions', ['action', 'closingMessage', 'autoReply']),
    ...mapState('settings', ['showTabSms', 'showTabEmail']),
    ...mapState('authentication', ['userProfile']),
    ...mapState('companies', ['company']),
  },

  watch: {
    'action.customMandatoryQuestion': function watchMandatoryQuestion(value) {
      if (!value) {
        let newArray = [];

        newArray = this.action.email.additionalQuestions;

        for (let i = 0; i < newArray.length; i += 1) {
          newArray[i].mandatory = false;
        }
        this.action.email.additionalQuestions = newArray;
      }
    },

    'action.channel': function watchActionChannel(value) {
      if (value !== 'sms') {
        this.checkRadioOptions = true;
        this.action.sms.config = this.action.sms.config || 'link';
      } else if (value === 'sms' && this.action.sms.config === 'link') {
        this.checkRadioOptions = true;
      } else {
        this.checkRadioOptions = false;
      }
    },
    'action.sms.config': function watchActionConfig(value) {
      if (value === 'body') {
        this.checkRadioOptions = false;
      } else {
        this.checkRadioOptions = true;
      }
    },
    'action.multiLanguage': function watchMultiLanguage(value) {
      if (value) {
        this.action.enableTranslation = false;
      }
    },
  },

  methods: {
    ...mapActions('actions', ['submit', 'updateAction', 'updateLogo', 'updateLogoInvitationLetter']),
    ...mapActions('templates', ['setList', 'updateTemplate']),

    async saveAction() {
      if (!this.validateFields()) {
        return;
      }

      this.loadingSave = true;
      // fix template 'custom'
      if (this.action.email.template.scale === 'custom') {
        this.action.email.template.scale = '#ffffff';
        this.action.email.template.border = '#000000';
        this.action.email.template.grade = '#000000';
      }

      this.action.langAlert = this.action.multiLanguage
        ? 'br'
        : this.action.langAlert;

        // if(this.action.type === 'like-dislike') {
        //   if(!this.action.reply.promoters && !this.action.reply.detractors) {
        //     this.action.feedbackDisabled = true;
        //   } else {
        //     this.action.feedbackDisabled = false;
        //   }

        // } else {
        //   if(!this.action.reply.promoters && !this.action.reply.neutral && !this.action.reply.detractors) {
        //     this.action.feedbackDisabled = true;
        //   } else {
        //     this.action.feedbackDisabled = false;
        //   }
        // }

      try {
        await this.updateAction({
          token: this.userAuth.token,
          id: this.action._id,
          data: this.action,
        });

        if (this.action.uploadedImage && this.action.useLogo) {
          await this.updateLogo({
            token: this.userAuth.token,
            actionId: this.action._id,
            uploadedImage: this.action.uploadedImage,
          });
        }

        if (this.action.email.template.emailTemplateCustom && this.action.email.template.emailTemplateCustom.headerLogo && this.action.email.template.emailTemplateCustom.enableHeaderLogo) {
          await this.updateLogoInvitationLetter({
            token: this.userAuth.token,
            actionId: this.action._id,
            uploadedImage: this.action.email.template.emailTemplateCustom.headerLogo,
          });
        }

        await this.updateClosingMessage();
        await this.updateAutoReply();

        if (!(['1', '2', '3'].indexOf(this.action.email.template.id) + 1)) {
          await this.updateTemplate({
            token: this.userAuth.token,
            id: this.action.email.template.id,
            data: {
              body: this.action.email.template.myHTML,
              scale: this.action.email.template.scale,
              border: this.action.email.template.border,
              grade: this.action.email.template.grade,
            },
          });
        }

        swal({
          title: this.$t('newAction.stepOne.actionSavedAlert'),
          text: this.$t('newAction.stepThree.wish'),
          icon: 'success',
          buttons: {
            leave: {
              text: this.$t('newAction.stepThree.continueAfter'),
              value: 'leave',
            },
            next: {
              text: this.$t('newAction.stepOne.skipSettings'),
              value: 'next',
            },
          },
        }).then((value) => {
          if (value === 'next') {
            this.$router.push(`/action/config/${this.action._id}`);
          } else if (value === 'leave') {
            this.$router.push('/action-list');
          }
        });
      } catch (error) {
        swal({
          title: this.$t('newAction.stepOne.messageError.title'),
          text: this.$t('newAction.stepOne.messageError.errorEditAction'),
          icon: 'error',
        });
      }

      this.loadingSave = false;
    },

    async updateClosingMessage() {
      if (this.action.closingMessageEnabled) {
        const headers = { 'x-access-token': this.userAuth.token };

        let response;

        if (this.closingMessage._id) {
          response = await api.put(
            `/action/closing-message/${this.closingMessage._id}`,
            this.closingMessage,
            { headers },
          );
        } else {
          response = await api.post(
            `/action/closing-message/${this.action._id}`,
            this.closingMessage,
            { headers },
          );
        }

        this.closingMessage._id = response.data._id;
      }
    },

    async updateAutoReply() {
      if (this.action.automaticAnswerEnabled) {
        const headers = { 'x-access-token': this.userAuth.token };

        let response;

        if (this.autoReply._id) {
          response = await api.put(
            `/action/auto-reply/${this.autoReply._id}`,
            (this.autoReply = {
              ...this.autoReply,
              updatedBy: this.userAuth._id,
            }),
            { headers },
          );
        } else {
          response = await api.post(
            `/action/auto-reply/${this.action._id}`,
            (this.autoReply = {
              ...this.autoReply,
              createdBy: this.userAuth._id,
            }),
            { headers },
          );
        }
        this.autoReply._id = response.data._id;
      }
    },

    validateFields() {
      const $actionName = document.getElementById('action-name-id');
      const $questionId = document.getElementById('question-id');
      const $switchPromoters = document.getElementById('switch-promoters');
      const $switchNeutral = document.getElementById('switch-neutral');
      const $switchDetractors = document.getElementById('switch-detractors');
      const $messageLink = document.getElementById('message-link-id');

      if ($actionName.value === '') {
        $actionName.classList.add('is-invalid');
        return false;
      }

      if ($questionId.value === '') {
        $questionId.classList.add('is-invalid');
        return false;
      }

      if (
        $switchPromoters.checked === true &&
        this.action.reply.promoters === null
      ) {
        document
          .getElementById('input-promoters-id')
          .classList.add('is-invalid');
        return false;
      }

      if (
        this.action.type !== 'like-dislike' &&
        $switchNeutral.checked === true &&
        this.action.reply.neutral === null
      ) {
        document.getElementById('input-neutral-id').classList.add('is-invalid');
        return false;
      }

      if (
        $switchDetractors.checked === true &&
        this.action.reply.detractors === null
      ) {
        document
          .getElementById('input-detractors-id')
          .classList.add('is-invalid');
        return false;
      }

      if (!this.validateAddQuestions()) {
        if (this.action.multiLanguage) {
          return true;
        }
        return false;
      }

      if (this.action.sms.msgLink === '' && this.action.sms.config === 'link') {
        $messageLink.classList.add('is-invalid');
        return false;
      }

      return true;
    },

    validateAddQuestions() {
      const $addQuestionsValue = document.querySelectorAll(
        '.addquestions-value',
      );

      let isValid = true;

      $addQuestionsValue.forEach((element) => {
        if (element.value === '') {
          element.classList.add('is-invalid');
          isValid = false;
        }
      });

      if (isValid) {
        return true;
      }

      return false;
    },
  },

  async created() {
    this.loading = true;

    this.userAuth = JSON.parse(localStorage.getItem('_indecx'));

    if (!this.userProfile.permissions.actions.edit) {
      this.$router.push(`/dashboard/${this.userAuth.companyId}`);
    }

    const fromPreview = JSON.parse(localStorage.getItem('_indecx_action'));

    if (fromPreview) {
      this.action = { ...fromPreview };
      localStorage.removeItem('_indecx_action');
    } else {
      const response = await api.get(`/action/${this.$route.params.id}`, {
        headers: {
          'x-access-token': this.userAuth.token,
        },
      });

      this.action = { ...response.data, uploadedImage: null };
    }

    this.setList({
      token: this.userAuth.token,
      companyId: this.userAuth.companyId,
    });

    EventBus.$on('editorPosition', (position) => {
      this.editorPosition = position;
      this.sectionPosition = 'collapse';
    });

    EventBus.$on('returnPosition', (position) => {
      this.editorPosition = 'col-6';
      this.sectionPosition = position;
    });

    this.loading = false;
  },
};
</script>

<style lang="scss" scoped>
@import '@/themes/default/variables.scss';
.wrapper {
  background-color: #fff;
  border: 1px solid $gray-light;
  padding: 16px 8px;
  border-radius: 4px;
  margin: 8px;
}

.vue-step-wrapper {
  background-color: #fff;
  border: 1px solid $gray-light;
  padding: 0 24px;
  border-radius: 4px;
  margin: 8px 8px 16px;
}

.content-template {
  padding: 0 10px;
}

.sectionPosition {
  display: none;
}

.fields-area {
  display: flex;
  flex-direction: row;
  align-items: center;

  button {
    max-height: 40px;
  }
}

.next-area {
  display: flex;
  justify-content: flex-end;
  padding: 0 30px;
}
.save-change{
  margin-top: 1rem;
}
</style>



// WEBPACK FOOTER //
// src/components/organisms/actions/step-one/index.vue